import React from 'react'
import "./testimonials.css"

const Testimonials = () => {
  return (
    <section id='testimonials'></section>
  )
}

export default Testimonials